import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import localize from "../../../common/localize";
import EventInfo from "./EventInfoTable";

const DonutChart = ({ chartTitle, chartSubtitle, chartData, showAsTabs }) => {
  const [array, setArray] = useState([100]);
  const [labels, setLabels] = useState(localize.total);
  const [colors, setColors] = useState(undefined);
  const [selectedTab, setSelectedTab] = useState("0");

  const showExecutionTime = (timeElapsed) => {
    if (timeElapsed) {
      return `${timeElapsed.days} ${localize.days}, ${timeElapsed.hours} ${localize.hours}, ${timeElapsed.minutes} ${localize.minutes}, ${timeElapsed.seconds} ${localize.seconds}`;
    }

    return undefined;
  };

  const createData = (fieldName, fieldValue, fieldType) => ({
    fieldName,
    fieldValue,
    fieldType,
  });

  const eventInfoData = () => {
    if (chartData?.data) {
      const dataTable = chartData.data.map(
        (x) => createData(`${x.label}`, `${showExecutionTime(x.timeElapsed)}`),
        "normal"
      );

      dataTable.push(
        createData(
          localize.total,
          `${showExecutionTime(chartData.timeElapsed)}`,
          "bold"
        )
      );
      return dataTable;
    }

    return [createData(localize.total, undefined, "event_data")];
  };

  const generateChart = (data, label, color) => ({
    series: data,
    options: {
      legend: {
        offsetY: 50,
      },
      colors: color,
      labels: label,
      subtitle: {
        text: chartSubtitle,
        align: "center",
      },
      title: {
        text: chartTitle,
        align: "center",
      },
      chart: {
        type: "donut",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: "50%",
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  const [randomState, setRandomState] = useState(
    generateChart([100], [localize.total], undefined)
  );

  useEffect(() => {
    if (chartData?.data) {
      setLabels(
        chartData?.data?.map((x) => `${x.label} (${x.value.toFixed(4)}%)`)
      );
      setColors(chartData?.data?.map((x) => x.backColor));
      setArray(chartData?.data?.map((x) => x.value));
    }
  }, [chartData]);

  useEffect(() => {
    if (array && labels) {
      setRandomState(generateChart(array, labels, colors));
    }
  }, [array]);

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div className="w-full lateral padding">
      {showAsTabs ? (
        <TabContext value={selectedTab} className="lateral_padding">
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleTabChange}>
              <Tab label={localize.graph} value="0" />
              <Tab label={localize.execution_times} value="1" />
            </TabList>
          </Box>

          <TabPanel value="0">
            <Chart
              options={randomState.options}
              series={randomState.series}
              type="donut"
              width="600px"
            />
          </TabPanel>

          <TabPanel value="1">
            <div
              className="w-full"
              style={{
                width: "600px",
                overflowY: "auto",
                maxHeight: "800px",
              }}
            >
              <EventInfo rows={eventInfoData()} customWidthPercentage="100%" />
            </div>
          </TabPanel>
        </TabContext>
      ) : (
        <Box className="flex flex-col gap-4 w-full">
          <Card variant="outlined" className="flex items-center justify-center p-2">
            <Chart
              options={randomState.options}
              series={randomState.series}
              type="donut"
              width="500px"
            />
          </Card>

          <Card variant="outlined">
            <EventInfo rows={eventInfoData()} customWidthPercentage="100%" />
          </Card>
        </Box>
      )}
    </div>
  );
};

export default DonutChart;
